import Vue from 'vue'
import { Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { tree, cc } from "../utils";
import { Item, InputRow, Node } from "../models";
import FormRows from "../parts/FormRows";
import App from '../App'
import { shuffle, sleep, normalizeModel, bakeRemoteData } from '../utils'
import SelectNode from '../parts/SelectNode'
import { remoteOp } from "../helper";

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

interface DoneState {
  kind: 'done';
  model: {[k: string]: any};
  modified: boolean;
}

type State = UnsetState | ErrorState | DoneState


const confirmMsg = '表单已被修改, 是否放弃保存?'

@Component({
  name: 'PortalItemCreate',
  components: { FormRows },

  beforeRouteUpdate(this: PortalItemCreate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  },

  beforeRouteLeave(this: PortalItemCreate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  }
})
export default class PortalItemCreate extends Vue {
  @Prop() type: string

  @Prop() inputs: InputRow[]

  @Prop() callbacks: {
    prepend: (item:Item)=>void;
    update: (item:Item)=>void;
  }

  itemId = 0

  state: State = {kind: 'unset'}

  busy = false

  private _unwatch?: (()=>void)

  get status() {
    return this.state.kind
  }

  get modified() {
    return this.state.kind === 'done'
        && this.state.modified
  }

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    if (this.$route.name === 'portal-item-create') {
      this.reset()
    }
  }

  beforeDestroy() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
  }

  private async reset() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
    this.busy = false
    if (!this.type || !this.inputs || this.inputs.length===0) {
      this.state = { kind: 'error', message: 'Invalid request' }
      return
    }
    this.state = {
      kind: 'done',
      model: normalizeModel({}, this.inputs),
      modified: false
    }
    let state = this.state
    this._unwatch = this.$watch('state.model', (oldValue, newValue) => {
      if (newValue && oldValue && newValue === oldValue)
        state.modified = true
    }, {deep: true})
  }

  save() {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    if (!state.modified) {
      if (!confirm('表单似乎未被修改, 是否继续?')) {
        return
      }
    }
    $(':focus', this.$el).blur()
    let data = bakeRemoteData(state.model, this.inputs)
    data.node_id = parseInt(this.$route.params.nodeId)
    data.type = this.type
    remoteOp(this, '保存', '项目', async () => {
      let result = await api.item.create(data)
      state.modified = false
      this.close()
      data.id = result.id
      data.update_time = result.update_time
      this.callbacks.prepend(data)
    })
  }

  close() {
    this.$router.replace({ name: 'portal-item-list' })
  }
}


